import { createAction } from 'redux-actions';

// Constants
export const SET_PROJECT = 'project/SET_PROJECT';

// Reducer
// This should be changed to no initial state. Until the new URL system is fully migrated keep this.
const initialState = 'akerbp';

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PROJECT:
      return action.payload;
    default:
      return state;
  }
};

// Action creators
export const setProject = createAction(SET_PROJECT);

export const actions = {
  setProject,
};



// WEBPACK FOOTER //
// ./src/modules/project/Project.js